import Samples from './Samples';

export default Samples;
